export default {"src":"/_next/static/media/add-grid-to-photo-online.138eece3.svg","height":630,"width":1200,"blurWidth":0,"blurHeight":0};